<template>
  <div class='home'>
    <JobPositionList
      v-show='listView'
      @newJobPosition='onClickNewFromList'
      @editJobPosition='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <JobPositionForm
      v-show='formView'
      :jobPosition='jobPosition'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import JobPositionList from '@/components/job-position/JobPositionList.vue'
import JobPositionForm from '@/components/job-position/JobPositionForm.vue'

export default {
  name: 'Job_Position',
  components: {
    JobPositionList,
    JobPositionForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      jobPosition: {
        uid: null,
        id: null,
        name: null,
        department_id: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.jobPosition = value
      this.jobPosition.uid = value.id
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.jobPosition = {
        uid: null,
        id: null,
        name: null,
        department_id: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.jobPosition = {
        uid: null,
        id: null,
        name: null,
        department_id: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getEmployeeDepartment')
  }
}
</script>
